export const getDefaultProfileImage = (email) => {
  const seed = email || 'default';
  return `https://api.dicebear.com/7.x/avataaars/svg?seed=${seed}`;
}; 